import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';

import { formatDateAndTime, getDuration } from '../../../utils/date';
import useStyles from './styles';

const SurveyQuestionBox = ({ questions, reaudit }) => {
  const { t } = useTranslation();
  const styles = useStyles();

  const { taskResponseId, type } = useParams();

  const questionIsPending = (isPending) => {
    switch (isPending) {
      case false:
        return (
          <p align="left" className={`${styles.tag} ${styles.tagCompleted}`}><b>{t('qa.status.completed')}</b></p>
        );
      case true:
        return (
          <p align="left" className={`${styles.tag} ${styles.tagPending}`}><b>{t('qa.status.pending')}</b></p>
        );
      default:
        return (
          <p align="left" className={`${styles.tag} ${styles.tagPending}`}><b>{t('qa.status.pending')}</b></p>
        );
    }
  };

  const formatTeleauditDate = (date) => (date ? formatDateAndTime(date) : '-');
  const showTeleauditDates = !reaudit;

  return (
    <div className={styles.root}>
      <Typography variant='h6'>
        {reaudit
          ? t('teleaudit.surveyQuestionBox.questionsReaudit')
          : t('teleaudit.surveyQuestionBox.questionsTeleaudit')}
      </Typography>
      <Table>
        {showTeleauditDates && (
          <TableHead>
            <TableRow>
              <TableCell align="left">{t('teleaudit.surveyQuestionBox.body.questionHeader')}</TableCell>
              <TableCell align="center">{t('teleaudit.surveyQuestionBox.body.imagesHeader')}</TableCell>
              <TableCell align="center">{t('teleaudit.surveyQuestionBox.body.status')}</TableCell>
              <TableCell align="left">{t('teleaudit.surveyQuestionBox.body.startDate')}</TableCell>
              <TableCell align="left">{t('teleaudit.surveyQuestionBox.body.finishDate')}</TableCell>
              <TableCell align="left">{t('teleaudit.surveyQuestionBox.body.duration')}</TableCell>
              <TableCell align="right">{t('teleaudit.surveyQuestionBox.body.action')}</TableCell>
            </TableRow>
          </TableHead>
        )}
        <TableBody>
          {questions.length > 0
            ? questions.map((questionResponse) => {
              const teleauditResponse = (questionResponse.TeleauditResponses || [])[0] || {};

              return (
                <TableRow key={questionResponse.id}>
                  <TableCell align="left"><b>{questionResponse.Question.title}</b></TableCell>
                  <TableCell align="center">
                    <b>
                      {questionResponse.questionResponseImageQuantity}
                      {questionResponse.questionResponseImageQuantity === 1
                        ? t('teleaudit.surveyQuestionBox.body.image')
                        : t('teleaudit.surveyQuestionBox.body.images')}
                    </b>
                  </TableCell>
                  <TableCell align="center">
                    {reaudit
                      ? (
                        <p align="left" className={`${styles.tag} ${styles.tagReaudit}`}>
                          <b>
                            Reaudit
                          </b>
                        </p>
                      )
                      : questionIsPending(questionResponse.teleauditStatus === 'pending')
                    }
                  </TableCell>
                  {showTeleauditDates && (
                    <TableCell align="left">
                      {formatTeleauditDate(teleauditResponse.startDate)}
                    </TableCell>
                  )}
                  {showTeleauditDates && (
                    <TableCell align="left">
                      {formatTeleauditDate(teleauditResponse.finishDate)}
                    </TableCell>
                  )}
                  {showTeleauditDates && (
                    <TableCell align="left">
                      {getDuration(
                        teleauditResponse.startDate,
                        teleauditResponse.finishDate,
                      ) || '-'}
                    </TableCell>
                  )}
                  <TableCell align="right">
                    <Button
                      onClick={() => {
                        const url = `/teleaudit/${taskResponseId}/${questionResponse.id}/${type}`;
                        window.open(url, '_blank');
                      }}
                      variant="contained"
                      className={clsx({ [styles.enableButton]: true })}
                      align='center'
                    >
                      {t('teleaudit.surveyQuestionBox.body.toTeleaudit')}
                    </Button>
                  </TableCell>
                </TableRow>
              );
            })
            : (
              <TableRow>
                <TableCell colSpan={showTeleauditDates ? 7 : 4} align="center">
                  <Typography variant="h6">{t('teleaudit.surveyQuestionBox.body.noQuestions')}</Typography>
                </TableCell>
              </TableRow>
            )}
        </TableBody>
      </Table>
    </div>
  );
};

export default SurveyQuestionBox;
